module.exports = __webpack_public_path__ + "static/media/pepe4.2a5a35ff.png";